import { FC } from 'react';
import { LIST_PRODUCT_ELEMENTS as ALL_ELEMENTS, TListProductElement } from 'mod/product-list/interface';
import listProductStyles from './index.module.less';
import { ListProduct as ModListProduct, IListProductProps } from 'mod/product-list/ListProduct';
import { ProductEnergyLabel } from '@pro/product-list/ProductEnergyLabel';

export { listProductStyles, ALL_ELEMENTS };

export type { TListProductElement };

const VIVOSUN_COMPONENTS = {
    energyLabel: ProductEnergyLabel,
};

export const DEFAULT_ELEMENTS: Array<TListProductElement | string> = [
    'title',
    'rate',
    'prices',
    'points',
    'options',
];

export const ListProduct: FC<IListProductProps> = props => {
    const {
        elements = DEFAULT_ELEMENTS,
        customElements,
        ...rest
    } = props;

    return (
        <ModListProduct
            elements={elements}
            customElements={{ ...VIVOSUN_COMPONENTS, ...customElements }}
            {...rest}
        />
    )
};